import { Outlet } from "react-router-dom";
import SidebarDashboard from "./SidebarDashboard";
import { useApp } from "../../context/AppContext";

const DashboardLayout = () => {
  const { siteSettings } = useApp();

  return (
    <>
      <style>
        {`
          /* Pastikan shell utama membentang penuh */
          .dashboard-shell {
            display: flex;
            min-height: 100vh;
            width: 100%;
            /* Latar belakang global Pink Pastel BukuOiBook */
            background-color: var(--color-slate-50, #fffafc); 
          }

          /* Konten utama membentang mengambil sisa ruang */
          .dashboard-main {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            min-width: 0; 
            transition: margin-left 0.3s ease;
          }

          .dashboard-topbar {
            padding: 30px 40px 10px 40px;
          }

          .dashboard-page-content {
            padding: 20px 40px 40px 40px;
          }

          /* ========================================= */
          /* PENYESUAIAN KHUSUS MOBILE RESPONSIVE      */
          /* ========================================= */
          @media (max-width: 991px) {
            .dashboard-main {
              margin-left: 0 !important; 
              width: 100% !important;
            }

            .dashboard-topbar {
              /* Jarak aman agar "Dashboard Admin" tidak tertutup tombol burger */
              padding-top: 75px !important; 
              padding-left: 20px !important;
              padding-right: 20px !important;
            }
            
            .dashboard-page-content {
              padding: 15px !important; 
            }
          }
        `}
      </style>
      <div className="dashboard-shell">
        <SidebarDashboard />
        <section className="dashboard-main">
          <div className="dashboard-topbar">
            <div>
              {/* NAMA DASHBOARD DINAMIS - Ukuran font dioptimasi dengan clamp untuk Mobile */}
              <h1 
                className="dashboard-title" 
                style={{ 
                  color: "#8e1628", 
                  fontWeight: "900", 
                  textTransform: "uppercase", 
                  fontSize: "clamp(1.2rem, 4vw, 1.8rem)", /* <-- Ukuran Dinamis */
                  margin: "0 0 5px 0" 
                }}
              >
                Dashboard {siteSettings?.siteName || "Solusi IoT Cerdas"}
              </h1>
              <p 
                className="dashboard-subtitle" 
                style={{ 
                  color: "#ec4899", 
                  fontWeight: "700", 
                  margin: "0",
                  fontSize: "clamp(0.85rem, 3vw, 1rem)" /* <-- Ukuran Dinamis */
                }}
              >
                Kelola data dan pengaturan untuk website {siteSettings?.siteName || "ini"}.
              </p>
            </div>
          </div>
          <div className="dashboard-page-content">
            <Outlet />
          </div>
        </section>
      </div>
    </>
  );
};

export default DashboardLayout;